import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { VENDORS } from "./apiRoutes";

interface UseGetVendorListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getVendorList = async (data: any) =>
  await axiosAuth.post(`${VENDORS}/grid`, data);

const useGetVendorList = ({
  data,
  queryParams,
}: UseGetVendorListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["vendors"],
    queryFn: () => getVendorList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetVendorList;
